import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import mSimcard from 'models/simcard';
// Custom
import { fullListShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';

const GroupSelectFieldFilter = ({ groupId, simcardGroups, onChange }) => {
  const sortedSimcardGroups = mSimcard.sortGroups(simcardGroups.elements.data);

  return (
    <ResourceSelectFieldFilter
      labelId="field.group"
      resourceId={groupId}
      resources={sortedSimcardGroups}
      displayKey="name"
      onChange={onChange}
    />
  );
};

GroupSelectFieldFilter.propTypes = {
  groupId: PropTypes.number,
  simcardGroups: fullListShape.isRequired,
  onChange: PropTypes.func.isRequired,
};

GroupSelectFieldFilter.defaultProps = {
  groupId: null,
};

const mapStateToProps = (state) => ({
  simcardGroups: state.simcardGroup.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(GroupSelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/groups/GroupSelectFieldFilter.js